import WOC_1388 from './scenarios/WOC-1388';
import WOC_1569 from './scenarios/WOC-1569';

export default [WOC_1388, WOC_1569];
